import { AppContextState, ExperimentState } from "@gamedev-web/gamedev-sdk-core";
import { uhfReducer, UhfState } from "@gamedev-web/gamedev-uhf";

import { appContextReducer } from "./appContext";
import { experimentReducer } from "./experimentReducer";

export type RootState = {
  appContext: AppContextState;
  experiments: ExperimentState;
  uhf: UhfState;
};

/**
 * Root Reducer Map is constructed in preparation for createInjectableStore which needs to store this map.
 */
export const RootReducerMap = {
  appContext: appContextReducer,
  experiments: experimentReducer,
  uhf: uhfReducer,
};
